import { createElement, type ElementType, type ReactNode } from "react";

type Props = {
  contentKey?: string;
  defaultValue: string;
  as?: ElementType;
  className?: string;
  multiline?: boolean;
  lineBreakClassName?: string;
  children?: (value: string) => ReactNode;
};

export function EditableText({
  defaultValue,
  as = "span",
  className,
  multiline,
  lineBreakClassName,
  children,
}: Props) {
  const renderContent = () => {
    if (children) return children(defaultValue);
    if (!multiline) return defaultValue;
    return defaultValue.split(/\r?\n|\\n/).map((line, i) => (
      <span key={i} className={i > 0 ? lineBreakClassName : undefined}>
        {i > 0 && <br />}
        {line}
      </span>
    ));
  };

  return createElement(as, { className }, renderContent());
}
